import React from 'react';
import { Button, Modal } from 'react-bootstrap';

// Shown when the address belongs to someone who is already a member of the
// organization the admin picked: there is nothing to invite them to, so this
// only reports it.
const ExistingMemberModal = ({ existingMember, orgList, handleClose }) => {
  const organizationName = orgList?.find((o) => o.id === existingMember?.organizationId)?.name;

  return (
    <Modal show={existingMember !== null} onHide={handleClose}>
      <Modal.Dialog>
        <Modal.Header closeButton>
          <Modal.Title>User Already in Organization</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>
            A user with the email <strong>{existingMember?.email}</strong> is already a member of{' '}
            {organizationName ? <strong>{organizationName}</strong> : 'this organization'}.
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" className="btn btn-custom dark" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal.Dialog>
    </Modal>
  );
};

export default ExistingMemberModal;
